import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputAdornment,
  Paper,
  TextField,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { format, parse } from 'date-fns';
import React from 'react';
import Utils from '../share/Utils';
import VariantSnackbar from '../share/VariantSnackbar';
import AuxilioSaudeApi from '../../api/AuxilioSaudeApi';
import FilterServidorSemVinculo from '../share/FilterServidorSemVinculo';
import BeneficiarioApi from '../../api/BeneficiarioApi';

const styles = theme => ({
  paper: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing(1),
    minWidth: 400,
  },
  formControlValor: {
    // margin: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(0.5),
    width: 250,
  },
  textFieldIdade: {
    // margin: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 80,
  },
  textFieldDtaReferencia: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    width: 300,
    marginRight: theme.spacing(2),
  },
  selectAnoProcesso: {
    width: 180,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  textFieldNumProcesso: {
    width: 180,
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(-1),
    // margin: theme.spacing(1) * -1.5,
  },
  selectOrigem: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(3),
    width: 830,
  },
  formControlObservacao: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(3),
    width: 830,
  },
  formControlValorInfo: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(3),
    width: 260,
  },
  invisible: {
    display: 'none',
  },
  textFieldTxtCodigoSei: {
    width: 400,
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  typographyInfo: {
    marginLeft: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontSize: 11
  },
});
class FormDialogAuxilioSaude extends React.Component {
  utils = new Utils();
  auxilioSaudeApi = new AuxilioSaudeApi();
  beneficiarioApi = new BeneficiarioApi();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.auxilio,
      fetching: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      codServidorSelected: this.props.auxilio.codServidor,
      seqDependenteSelected: this.props.auxilio.seqDependente,
      nomeServidorSelected: this.props.auxilio.nomeBeneficiario,
      snackOpen: false,
      idade: '',
      snackMessage: '',
      sucesso: false,
      errorMessageValor: '',
      errorMessageData: '',
      openFullScreenFaixas: false
    };    
    this.state.valPago = this.state.valPago === undefined ? '' : this.state.valPago;
    this.state.valReferencia = this.state.valReferencia === undefined ? '' : this.state.valReferencia;
    this.state.valAuxilio = this.state.valAuxilio === undefined ? '' : this.state.valAuxilio;
    this.state.dtaReferencia = format(parse(this.state.dtaReferencia), 'YYYY-MM-DD');
  }

  componentDidMount = async () => {
    if (this.props.auxilio.codServidor !== undefined && this.props.auxilio.codServidor !== null) {
      await this.consultarIdade();
    }
  }

  consultarIdade = async () => {
    let idade = await this.beneficiarioApi.consultarIdade(this.state.codServidorSelected, this.state.seqDependenteSelected, String(this.state.dtaReferencia));
    this.setState({idade: idade});
  }

  consultarValorReferencia = async () => {
    let idade = await this.beneficiarioApi.consultarIdade(this.state.codServidorSelected, this.state.seqDependenteSelected, String(this.state.dtaReferencia));
    let valReferencia = await this.auxilioSaudeApi.consultarValorReferencia(this.state.codServidorSelected, this.state.seqDependenteSelected, String(this.state.dtaReferencia));
    this.setState({valReferencia: String(valReferencia) + ",00", idade: idade});
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  handleClickLimpar = async () => {
    this.setState({
      codigoSelected: '',
      nomeServidorSelected: '',
      codServidorSelected: 0,
      seqDependenteSelected: 0,
      idade: '',
    });
  }

  handleSelectBeneficiario = async (codigo, nome) => {
    this.setState({
      codigoSelected: codigo,
      nomeServidorSelected: nome,
      codServidorSelected: Number(codigo.substring(0, 5)),
      seqDependenteSelected: Number(codigo.substring(6, 9)),      
      });
      if (this.state.dtaReferencia !== '' && this.state.dtaReferencia !== 'Invalid Date'){
        await this.consultarIdade();
        await this.consultarValorReferencia();
      }
  }

  handleBlurValor = () => {
    if (this.state.valPago === '' || this.state.valPago === null || this.state.valPago === undefined) {
      this.setState({errorMessageValor: 'Favor preencher o valor'});
    } else {
      this.setState({valAuxilio: Number(this.state.valPago.replace(',', '.')) <= Number(this.state.valReferencia.replace(',', '.')) ? this.state.valPago : this.state.valReferencia});
    }
  }

  handleBlurData = async () => {
    if (this.state.dtaReferencia === null ||
      this.state.dtaReferencia === undefined ||
      this.state.dtaReferencia === '') {
      this.setState({errorMessageData: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageData: ''});      
      await this.consultarValorReferencia();
    }
  }

  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valPago') {
      valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValor: '' });
    }
    if (event.target.name === 'txtProcessoSei') {
      this.setState({ [event.target.name]: event.target.value.toUpperCase().substring(0, 20) });
    }
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleChangeObservacao = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  isSalvarDisabled = () => {
    return (this.state.errorMessageValor !== '' ||
    this.state.valAuxilio === undefined ||
    this.state.valAuxilio === 0 ||
    this.state.valAuxilio === '') ||

    (this.state.errorMessageData !== '' ||
     this.state.dtaReferencia === undefined ||
     this.state.dtaReferencia === 'Invalid Date' ||
     this.state.dtaReferencia === '') ||

    (this.state.nomeServidorSelected === '' ||
     this.state.nomeServidorSelected === undefined) ;

  }

  handleClickSave = async () => {
    const acerto = {
      numProtocolo: this.state.numProtocolo === undefined ? 0 : this.state.numProtocolo,
      codServidor: this.state.codServidorSelected === undefined ? 0 : this.state.codServidorSelected,
      seqDependente: this.state.seqDependenteSelected === undefined ? 0 : this.state.seqDependenteSelected,
      nomeBeneficiario: '',
      valPago: this.state.valPago.replace('.', '').replace(',', '.'),
      valReferencia: this.state.valReferencia.replace('.', '').replace(',', '.'),
      valAuxilio: this.state.valAuxilio.replace('.', '').replace(',', '.'),
      codEstado: this.state.codEstado === undefined ? 0 : this.state.codEstado,
      desEstado: '',
      txtObservacao: this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      dtaCadastro: null,
      dtaReferencia: this.state.dtaReferencia === undefined ? null : parse(this.state.dtaReferencia),
      txtProcessoSei: this.state.txtProcessoSei === undefined || this.state.txtProcessoSei === null ? '' : this.state.txtProcessoSei,
    };
    await this.props.handleSave(acerto);
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl component='fieldset' className={classes.formControlAutoCompleteBenef}>
                <FilterServidorSemVinculo
                  beneficiarios={this.props.nomesBeneficiarios}
                  disabled={!this.props.isEditavel}
                  nomeInicial={this.state.nomeBeneficiario}
                  carteiraInicial={this.state.numMatricula}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimpar} />
              </FormControl>
              <FormControl>
                <TextField
                  id='idade'
                  name='idade'
                  value={this.state.idade}
                  margin='dense'
                  disabled
                  fullWidth
                  style={{ maxlength: '40' }}
                  className={classes.textFieldIdade}
                  label={'Idade'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id='date'
                  disabled={!this.props.isEditavel || this.state.codServidorSelected === 0}
                  error={this.state.errorMessageData !== ''}
                  label={this.state.errorMessageData !== '' ? this.state.errorMessageData : 'Data Referência *'}
                  type='date'
                  value={this.state.dtaReferencia}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurData}
                  inputProps={{
                    name: 'dtaReferencia',
                  }}
                  className={classes.textFieldDtaReferencia}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id='txtProcessoSei'
                  name='txtProcessoSei'
                  value={this.state.txtProcessoSei}
                  margin='dense'
                  fullWidth
                  style={{ maxlength: '40' }}
                  disabled={!this.props.isEditavel}
                  onChange={this.handleChangeTextField}
                  className={classes.textFieldTxtCodigoSei}
                  label={'Processo SEI'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControlValor}>
                <TextField
                  value={this.state.valPago === null ? '0,00' : this.utils.formataValor(this.state.valPago)}
                  disabled={!this.props.isEditavel}
                  margin='dense'
                  id='valPago'
                  name='valPago'
                  error={this.state.errorMessageValor !== ''}
                  label={this.state.errorMessageValor !== '' ? this.state.errorMessageValor : 'Valor Pago pelo Benef.'}
                  fullWidth
                  onChange={this.handleChangeTextField}
                  onBlur={this.handleBlurValor}
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControlValor}>
                <TextField
                  value={this.state.valReferencia === null ? '0,00' : this.utils.formataValor(this.state.valReferencia)}
                  disabled
                  margin='dense'
                  id='valReferencia'
                  name='valReferencia'
                  label={'Val. Referência (Ato nº 150/2023)'}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControlValor}>
                <TextField
                  value={this.state.valAuxilio === null ? '0,00' : this.utils.formataValor(this.state.valAuxilio)}
                  disabled
                  margin='dense'
                  id='valAuxilio'
                  name='valAuxilio'
                  label={'Valor do Auxílio'}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                  margin='dense'
                  disabled={!this.props.isEditavel}
                  id='txtObservacao'
                  name='txtObservacao'
                  label='Observação'
                  fullWidth
                  onChange={this.handleChangeObservacao}
                  multiline
                  style={{maxlength: '1000'}}
                  maxRows='10'
                  helperText='(max. 1.000 caracteres)'
                />
              </FormControl>
            </Paper>
            <Typography className={classes.typographyInfo}>*A Data Referência é a data em que o servidor pagou o plano particular contratado</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogAuxilioSaude);
